import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import {useDispatch} from 'react-redux';
import {navigateNext} from '../../action/actions';
import Api from '../../util/api';

const ButtonNext = ({navigateDeviceNext = true, navigateDeviceTo = null}) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        if (navigateDeviceNext || navigateDeviceTo) {
            if (navigateDeviceTo !== null) {
                Api.navigateDeviceToPage(navigateDeviceTo).then(
                    () => dispatch(navigateNext())
                );
            } else {
                Api.navigateDeviceNext().then(
                    () => dispatch(navigateNext())
                );
            }
        } else {
            dispatch(navigateNext());
        }
    };

    return (
        <div style={styles.container}>
            <div style={{width: '250px', position: 'relative'}}>
                <Button onClick={handleClick} color={'pink'} text={'Volgende'}/>
                <div style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    backgroundColor: 'transparent',
                    left: 0,
                    top: 0,
                    right: -50,
                    bottom: 20,
                    zIndex: 1000
                }}  onClick={handleClick}/>
            </div>
        </div>
    );
}

ButtonNext.propTypes = {
    navigateDeviceNext: PropTypes.bool,
    navigateDeviceTo: PropTypes.number,
}

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
    },
}

export default ButtonNext;
